import { Component, OnDestroy, Renderer2, ViewChild } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter, Subscription } from 'rxjs';
import { LayoutService } from "./service/app.layout.service";
import { AppSidebarComponent } from "./app.sidebar.component";
import { AppTopBarComponent } from './app.topbar.component';
import { ApiService } from '../services/api/api.service';

@Component({
    standalone: false,
    selector: 'app-layout',
    templateUrl: './app.layout.component.html',
})
export class AppLayoutComponent implements OnDestroy {

    overlayMenuOpenSubscription: Subscription;

    menuOutsideClickListener: any;

    profileMenuOutsideClickListener: any;

    @ViewChild(AppSidebarComponent) appSidebar!: AppSidebarComponent;

    @ViewChild(AppTopBarComponent) appTopbar!: AppTopBarComponent;

    currentUser: any;
    selectedCompany: any;
    companies: any;
    selectedOrganisation: any;
    organisations: any;
    modalCompaniesVisible: boolean = false;
    modalOrganisationsVisible: boolean = false;

    constructor(public layoutService: LayoutService, public renderer: Renderer2, public router: Router, public apiService: ApiService) {
        this.overlayMenuOpenSubscription = this.layoutService.overlayOpen$.subscribe(() => {
            if (!this.menuOutsideClickListener) {
                this.menuOutsideClickListener = this.renderer.listen('document', 'click', event => {
                    const isOutsideClicked = !(this.appSidebar.el.nativeElement.isSameNode(event.target) || this.appSidebar.el.nativeElement.contains(event.target)
                        || this.appTopbar.menuButton.nativeElement.isSameNode(event.target) || this.appTopbar.menuButton.nativeElement.contains(event.target));

                    if (isOutsideClicked) {
                        this.hideMenu();
                    }
                });
            }

            if (!this.profileMenuOutsideClickListener) {
                this.profileMenuOutsideClickListener = this.renderer.listen('document', 'click', event => {
                    const isOutsideClicked = !(this.appTopbar.menu.nativeElement.isSameNode(event.target) || this.appTopbar.menu.nativeElement.contains(event.target)
                        || this.appTopbar.topbarMenuButton.nativeElement.isSameNode(event.target) || this.appTopbar.topbarMenuButton.nativeElement.contains(event.target));

                    if (isOutsideClicked) {
                        this.hideProfileMenu();
                    }
                });
            }

            if (this.layoutService.state.staticMenuMobileActive) {
                this.blockBodyScroll();
            }
        });

        this.router.events.pipe(filter(event => event instanceof NavigationEnd))
            .subscribe(() => {
                this.hideMenu();
                this.hideProfileMenu();
            });

        this.getUserAndCompany();
    }

    getUserAndCompany() {
        this.currentUser = this.apiService.currentUser;
        if (!this.currentUser) {
            this.apiService.currentUserChange.subscribe((user) => {
                this.currentUser = user;
                if (localStorage.getItem('currentCompany')) {
                    this.selectedCompany = JSON.parse(localStorage.getItem('currentCompany'));
                } else {
                    this.selectedCompany = this.currentUser.companies[0];
                }

                if (localStorage.getItem('currentOrganisation')) {
                    this.selectedOrganisation = JSON.parse(localStorage.getItem('currentOrganisation'));
                } else {
                    this.selectedOrganisation = this.currentUser.organisations[0];
                }
                if (!this.currentUser.is_superadmin && this.currentUser.organisations.length > 1) {
                    this.organisations = this.currentUser.organisations;
                }

                if (!this.currentUser.is_superadmin && this.currentUser.companies.length > 1) {
                    this.companies = this.currentUser.companies;

                    // filter to keep only the companies that do not have a organisation_id or where the organisation_id is this.selectedOrganisation.id
                    this.companies = this.companies.filter((company: any) => {
                        // return !company.organisation_id || company.organisation_id === this.selectedOrganisation.id;
                        return (!company.organisation_id || company.organisation_id === this.selectedOrganisation.id) && company.pivot;
                    });

                    // for the companies that have a organisation_id, add (organisation_name) to the company name
                    this.companies = this.companies.map((company: any) => {
                        if (company.organisation_id) {
                            company.name = company.name + ' (' + this.selectedOrganisation.name + ')';
                        }

                        if (company.is_knowledge) {
                            company.name = company.name + ' (Base de connaissance)';
                        }
                        return company;
                    });
                }
            });
        } else {
            if (localStorage.getItem('currentCompany')) {
                this.selectedCompany = JSON.parse(localStorage.getItem('currentCompany'));
            } else {
                this.selectedCompany = this.currentUser.companies[0];
            }

            if (localStorage.getItem('currentOrganisation')) {
                this.selectedOrganisation = JSON.parse(localStorage.getItem('currentOrganisation'));
            } else {
                this.selectedOrganisation = this.currentUser.organisations[0];
            }
        }

        this.companies = this.apiService.companies;
        if (!this.companies) {
            this.apiService.companiesChanges.subscribe((companies) => {
                this.companies = companies;

                this.companies = this.companies.filter((company: any) => {
                    return !company.organisation_id || company.organisation_id === this.selectedOrganisation.id;
                });

                this.companies = this.companies.map((company: any) => {
                    if (company.organisation_id) {
                        company.name = company.name + ' (' + this.selectedOrganisation.name + ')';
                    }

                    if (company.is_knowledge) {
                        company.name = company.name + ' (Base de connaissance)';
                    }
                    return company;
                });
            });
        }

        this.organisations = this.apiService.organisations;
        if (!this.organisations) {
            this.apiService.organisationsChanges.subscribe((organisations) => {
                this.organisations = organisations;
            });
        }
    }

    hideMenu() {
        this.layoutService.state.overlayMenuActive = false;
        this.layoutService.state.staticMenuMobileActive = false;
        this.layoutService.state.menuHoverActive = false;
        if (this.menuOutsideClickListener) {
            this.menuOutsideClickListener();
            this.menuOutsideClickListener = null;
        }
        this.unblockBodyScroll();
    }

    hideProfileMenu() {
        this.layoutService.state.profileSidebarVisible = false;
        if (this.profileMenuOutsideClickListener) {
            this.profileMenuOutsideClickListener();
            this.profileMenuOutsideClickListener = null;
        }
    }

    blockBodyScroll(): void {
        if (document.body.classList) {
            document.body.classList.add('blocked-scroll');
        }
        else {
            document.body.className += ' blocked-scroll';
        }
    }

    unblockBodyScroll(): void {
        if (document.body.classList) {
            document.body.classList.remove('blocked-scroll');
        }
        else {
            document.body.className = document.body.className.replace(new RegExp('(^|\\b)' +
                'blocked-scroll'.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
        }
    }

    get containerClass() {
        return {
            'layout-theme-light': this.layoutService.config().colorScheme === 'light',
            'layout-theme-dark': this.layoutService.config().colorScheme === 'dark',
            'layout-overlay': this.layoutService.config().menuMode === 'overlay',
            'layout-static': this.layoutService.config().menuMode === 'static',
            'layout-static-inactive': this.layoutService.state.staticMenuDesktopInactive && this.layoutService.config().menuMode === 'static',
            'layout-overlay-active': this.layoutService.state.overlayMenuActive,
            'layout-mobile-active': this.layoutService.state.staticMenuMobileActive,
            'p-input-filled': this.layoutService.config().inputStyle === 'filled',
            'p-ripple-disabled': !this.layoutService.config().ripple
        }
    }

    showDialogCompanies() {
        this.modalCompaniesVisible = true;
    }

    showDialogOrganisations() {
        this.modalOrganisationsVisible = true;
    }

    onCompanyChange() {
        this.apiService.setCurrentCompany(this.selectedCompany, true);
        this.apiService.fetchingAllChanges.subscribe((fetching) => {
            this.modalCompaniesVisible = fetching;
        });
    }

    onOrganisationChange() {
        this.apiService.setCurrentOrganisation(this.selectedOrganisation, true);
        this.modalOrganisationsVisible = false;
    }

    ngOnDestroy() {
        if (this.overlayMenuOpenSubscription) {
            this.overlayMenuOpenSubscription.unsubscribe();
        }

        if (this.menuOutsideClickListener) {
            this.menuOutsideClickListener();
        }
    }
}
